import { Component, HostListener, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef, ChangeDetectorRef } from '@angular/core';
import { DOData, DocdefDataVM, NJDocData, NJDocDefTemplate, componentVM } from "../DOData";
import { DocDefPrimLibService } from '../../doc-def-prim-lib.service';
@Component({
    selector: 'cy-dotext-box',
    templateUrl: './dotext-box.component.html',
    styleUrls: ['./dotext-box.component.css']
})
export class DOTextBoxComponent implements OnInit {

    @Input() DocDefTemplate: NJDocDefTemplate
    @Input() customParameters: any
    private _docData: NJDocData;
    @Input() set DocData(doData: NJDocData) {
        this._docData = doData;
        this.txtDocData = this.DocData;
        this.txtValue = this._docData.dataValue;
    }
    @Input() skipPostDocDefData: boolean;
    get DocData(): NJDocData {
        return this._docData;
    }
    @Input() public loaderKey: string;
    @Input() isValid: boolean;
    @Input() RowSelected: any;
    //@Input() isEnabled: boolean;
    private _isEnabled: boolean = true;
    @Input() public set isEnabled(t: boolean) {
        this._isEnabled = t;
    }
    public get isEnabled(): boolean {
        return this._isEnabled;
    }
    @Input() isPopUpYesNo: string = "Neither";
    //Keep API from firing if not needed.
    @Input() public ignorLabel: boolean = false;
    isLoading: boolean = false;
    //use for zip code field
    @Input() public hasEvent: boolean = false;
    //used to avoid race condition caused by onblur updating loader. Caller will reset hasEvent before update completed.
    // fireEventBefore and fireEventAfter fires before and after
    // fireEventBefore only before
    // hasEvent only after
    localhasEvent: boolean
    //31993 - Textarea delay fixed
    @HostListener(':input')
    onInput() {
        if (this.customParameters.Textarea) {
            this.adjust();
        }
    }
    @Output() clickBut: EventEmitter<DOData> =
        new EventEmitter<DOData>();
    @Output() tbDblClick: EventEmitter<DOData> =
        new EventEmitter<DOData>();
    @Output() tabEvent: EventEmitter<componentVM> = new EventEmitter<componentVM>();
    @Output() textBoxAfterViewInit: EventEmitter<DOTextBoxComponent> = new EventEmitter<DOTextBoxComponent>();

    txtDocDefTemplate: NJDocDefTemplate
    txtDocData: NJDocData
    errorMessage: string;
    StylesText: any;
    TextBoxStyle: any;
    TextBoxStyles: any;
    TextBoxClasses: any;
    rows: string = "4";
    inputType : string = "text";
    textAreaHeight: string = "";
    showTestText: number = 0;
    boolUseTestText: boolean = false;
    MaxLength: string = "8000"
    tabEventSent: boolean = false;
    public isHidden: boolean = false;
    public shouldSaveBeforeContinuing: boolean = false;
    public hasSavedSoContinue: boolean = false;

    @ViewChild("TestText") TestTextElem: ElementRef;

    LabelStylesText: any
    public isDirty: boolean = false
    public isDeactivateDirty: boolean = false
    isReadOnly: boolean = false;
    private onKeydownKey: any;

    constructor(private data: DocDefPrimLibService, private element: ElementRef, private changeDetectorRef: ChangeDetectorRef) { }
    get txtValue(): string {
        if (this.customParameters.ValueToBlank != null) {
            if (this.txtDocData.dataValue == this.customParameters.ValueToBlank)
                this.txtDocData.dataValue = "";
        }
        if (this.customParameters.Textarea) {
            if (this.showTestText <= 1 || !this.boolUseTestText)
                this.setTextHeight();
        }
        return this.txtDocData.dataValue;
    }
    set txtValue(TxtValue: string) {
        if (!this.isLoading) {
            if (this.txtDocData.dataValue != TxtValue) {
                this.txtDocData.dataValue = TxtValue;
                if (this.customParameters.isPhone != null) {
                    TxtValue = this.fmtPhone(TxtValue);
                    this.txtDocData.dataValue = TxtValue;
                }
                if (this.customParameters.isSSN != null) {
                    TxtValue = this.fmtSSN(TxtValue);
                    this.txtDocData.dataValue = TxtValue;
                }
                if (this.customParameters.isNumeric != null) {
                    TxtValue = this.NumericOnly(TxtValue);
                    this.txtDocData.dataValue = TxtValue;
                }
                if (this.customParameters.dateFmt != null) {
                    this.txtValue = this.fmtDate(TxtValue);
                    this.txtDocData.dataValue = TxtValue;
                }
                this.isDirty = true;
            }
        }
    }
    onKeydown(event) {
        this.shouldSaveBeforeContinuing = true;
        this.hasSavedSoContinue = false;
        if (this.hasEvent) {
            this.isDirty = true;
            this.onKeydownKey = event.key;
            this.onBlurText();
        }
    }
    private fmtDate(value): string {
        let d = new Date(value);
        let month = '' + (d.getMonth() + 1);
        let day = '' + d.getDate();
        let year = d.getFullYear();

        if (month.length < 2) month = '0' + month;
        if (day.length < 2) day = '0' + day;
        let ret = "";
        switch (this.customParameters.dateFmt) {
            case "yyyy-MM-dd":
                ret = [year, month, day].join('-');
                break;
            case "MM-dd-yyyy":
                ret = [month, day, year].join('-');
                break;
            case "yyyy/MM/dd":
                ret = [year, month, day].join('/');
                break;
            case "MM/dd/yyyy":
                ret = [month, day, year].join('/');
                break;
            case "24HR":
                {
                    let intHours = d.getHours();
                    let minutes = '' + d.getMinutes();
                    let seconds = '' + d.getSeconds();
                    if (intHours === 0) intHours = 12;
                    let hours = '' + intHours;
                    if (hours.length < 2) hours = '0' + hours;
                    if (minutes.length < 2) minutes = '0' + minutes;
                    if (seconds.length < 2) seconds = '0' + seconds;
                    ret = "MM/dd/yyyy hh:mm:ss";
                    ret = ret.replace("MM", month);
                    ret = ret.replace("dd", day);
                    ret = ret.replace("yyyy", year.toString());
                    ret = ret.replace("hh", hours);
                    ret = ret.replace("mm", minutes);
                    ret = ret.replace("ss", seconds);
                    break;
                }
            case "AMPM":
                {
                    let intHours = d.getHours();
                    let minutes = '' + d.getMinutes();
                    let xm = intHours > 12 ? "PM" : "AM";
                    if (value.includes('PM')) {
                        xm = 'PM';
                    } else if (value.includes('AM')) {
                        xm = 'AM';
                    }
                    if (intHours > 12) intHours -= 12;
                    if (intHours === 0) intHours = 12;
                    let hours = '' + intHours;
                    if (hours.length < 2) hours = '0' + hours;
                    if (minutes.length < 2) minutes = '0' + minutes;
                    ret = "MM/dd/yyyy hh:mm xm";
                    ret = ret.replace("MM", month);
                    ret = ret.replace("dd", day);
                    ret = ret.replace("yyyy", year.toString());
                    ret = ret.replace("hh", hours);
                    ret = ret.replace("mm", minutes);
                    ret = ret.replace("xm", xm);
                    break;
                }
            case "AMPMwSeconds":
                {
                    let intHours = d.getHours();
                    let minutes = '' + d.getMinutes();
                    let seconds = '' + d.getSeconds();
                    let xm = intHours > 12 ? "PM" : "AM";
                    if (value.includes('PM')) {
                        xm = 'PM';
                    } else if (value.includes('AM')) {
                        xm = 'AM';
                    }
                    if (intHours > 12) intHours -= 12;
                    if (intHours === 0) intHours = 12;
                    let hours = '' + intHours;
                    if (hours.length < 2) hours = '0' + hours;
                    if (minutes.length < 2) minutes = '0' + minutes;
                    // Fix for Ticket #32456
                    if (seconds.length < 2) seconds = '0' + seconds;
                    ret = "MM/dd/yyyy hh:mm:ss xm";
                    ret = ret.replace("MM", month);
                    ret = ret.replace("dd", day);
                    ret = ret.replace("yyyy", year.toString());
                    ret = ret.replace("hh", hours);
                    ret = ret.replace("mm", minutes);
                    ret = ret.replace("ss", seconds);
                    ret = ret.replace("xm", xm);
                    break;
                }
            default:
                {
                    if (this.customParameters.dateFmt.length > 10) {
                        let intHours = d.getHours();
                        let minutes = '' + d.getMinutes();
                        let seconds = '' + d.getSeconds();
                        let xm = intHours > 12 ? "PM" : "AM";
                        if (intHours > 12) intHours -= 12;
                        if (intHours === 0) intHours = 12;
                        let hours = '' + intHours;
                        if (hours.length < 2) hours = '0' + hours;
                        if (minutes.length < 2) minutes = '0' + minutes;
                        if (seconds.length < 2) seconds = '0' + seconds;
                        ret = this.customParameters.dateFmt;
                        ret = ret.replace("MM", month);
                        ret = ret.replace("dd", day);
                        ret = ret.replace("yyyy", year.toString());
                        ret = ret.replace("hh", hours);
                        ret = ret.replace("mm", minutes);
                        ret = ret.replace("ss", seconds);
                        ret = ret.replace("xm", xm);
                    }
                    else {
                        ret = [month, day, year].join('-');
                    }
                    break;
                }
        }
        if ((month === "1" || month === "01") && (day === "1" || day === "01") && year.toString() === "1900")
            ret = "";
        return ret;
    }
    private fmtSSN(value): string {
        var val = value.replace(/\D/g, '');
        val = val.replace(/^(\d{3})/, '$1-');
        val = val.replace(/-(\d{2})/, '-$1-');
        val = val.replace(/(\d)-(\d{4}).*/, '$1-$2');
        return val == "" ? value : val;
    }
    private fmtPhone(value): string {
        var lenDiff = value.length;
        if (this.txtDocDefTemplate.templateCode == 'OOH_PHYSICALHEALTH_TOSection_PHYSICALHEALTH_TextBox') { //ALM-32796
            if (value.startsWith('1')) {
                var x = value.replace(/\D/g, '').match(/(\d{0,1})(\d{0,3})(\d{0,3})(\d{0,4})/);
                value = !x[3] ? x[1] + x[2] : '1 (' + x[2] + ') ' + x[3] + (x[4] ? '-' + x[4] : '');
            } else {
                var x = value.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
                value = !x[2] ? x[1] : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : '');
            }
        } else {
            var x = value.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
            value = !x[2] ? x[1] : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : '');
        }

        //if junk was typed in then the above code will strip it out, but we need to create a new string to override the junk.
        if (lenDiff - value.length > 0) {
            value = new String(value);
        }
        return value;
    }
    private NumericOnly(value): string {
        var lenDiff = value.length;
        value = value.replace(/\D+/g, '');
        //if junk was typed in then the above code will strip it out, but we need to create a new string to override the junk.
        if (lenDiff - value.length > 0) {
            value = new String(value);
        }
        return value;
    }

    //setTextHeight Adjust the height of the INvisible textarea
    setTextHeight(): void {
        //if (this.customParameters['Textarea'] != null) {
        //    const lsttextAreas = this.element.nativeElement.getElementsByTagName('textarea')
        //    if (lsttextAreas.length > 1 || !this.boolUseTestText) {
        //        let idx: number = 0;
        //        if (this.boolUseTestText)
        //            idx = 1;
        //        const textArea = this.element.nativeElement.getElementsByTagName('textarea')[idx];
        //        textArea.value = this.txtDocData.dataValue;
        //        textArea.style.height = 'auto';
        //        textArea.style.width = '100%';
        //        textArea.style.overflow = 'hidden';
        //        this.textAreaHeight = textArea.scrollHeight + 'px';
        //    }
        //}
    }
    //Adjust the height of the visible textarea
    adjust(): void {
        //const textArea = this.element.nativeElement.getElementsByTagName('textarea')[0];
        //if (this.isDirty) {
        //    textArea.style.height = 'auto';
        //    textArea.style.overflow = 'hidden';
        //    textArea.style.height = textArea.scrollHeight + 'px';
        //    this.textAreaHeight = textArea.style.height;
        //} else {
        //    textArea.style.overflow = 'hidden';
        //    textArea.style.height = this.textAreaHeight;
        //}
        if (this.customParameters['Textarea'] != null) {
            if (this.customParameters['rows']) {
                this.rows = this.customParameters['rows'];
            }
            else {
                const textArea = this.element.nativeElement.getElementsByTagName('textarea')[0];
                if (textArea && textArea.scrollHeight) {
                    if (textArea.scrollHeight > 0) {
                        if (this.customParameters['MaxHeight'] != null) {
                            textArea.style.height = this.customParameters['MaxHeight'];
                            textArea.resize = 'none';
                        }
                        else {
                            textArea.style.height = 'auto';
                            textArea.style.overflow = 'hidden';
                        }
                        textArea.style.height = textArea.scrollHeight + 'px';
                    }
                }
            }
        }
    }
    getId(): string {
        let id: string = "";
        if (this.customParameters.Textarea != null)
            if (this.DocData.docDefDataRowID)
                id = this.DocDefTemplate.templateCode + this.DocData.docDefDataRowID.toString();
            else
                id = this.DocDefTemplate.templateCode;
        return id;
    }
    //ngAfterContentChecked() {
    //    //let id = this.getId();
    //    if (this.TestTextElem && this.customParameters.Textarea != null) {
    //        this.showTestText++;
    //    }

    //}
    onBlurText() {
        //this.changeDetectorRef.detectChanges();        
        if (this.customParameters.fireEventBefore) {
            this.localhasEvent = false;
            if (this.hasEvent) {
                let DOMessage: DOData = new DOData();
                DOMessage.njDocData = this.DocData;
                this.DocDefTemplate.indent = this.onKeydownKey;
                DOMessage.njDocDefTemplate = this.DocDefTemplate;
                this.onKeydownKey = "";
                this.clickBut.emit(DOMessage);
            }
        } else {
            this.localhasEvent = this.hasEvent;
        }
        this.isDeactivateDirty = true;
        //Made this change to bypass the PostDocDefData calls in welcome pages quick Search
        if ((this.customParameters.skipPostDocDefData == "True" || this.skipPostDocDefData == true) && this.customParameters.DontskipPostDocDefData != "True") {
            return this.onSaveComplete();
        }
        else {
            if (this.isPopUpYesNo == "Yes")
                this.isDirty = false;
            if (!this.isLoading && this.isDirty) {
                let lstDocData: DocdefDataVM = new DocdefDataVM();
                lstDocData.docdata.push(this.txtDocData);
                lstDocData.loaderKey = this.loaderKey;
                var _this = this;
                this.data.saveDocDefData(lstDocData)
                    .subscribe(function () {
                        _this.hasSavedSoContinue = true;
                        _this.shouldSaveBeforeContinuing = false;
                        _this.isDirty = false;
                        return _this.onSaveComplete();
                    }, function (error) {
                        _this.isDirty = false;
                        return _this.errorMessage = error;
                    });
            }
        }

    }
    evCallBackWhenClean: DOData;
    evComponent: any
    CallBackWhenClean(ev, component) {
        this.evCallBackWhenClean = ev;
        this.evComponent = component;
    }
    onSaveComplete = function () {
        if (this.evCallBackWhenClean) {
            let ev = DocDefPrimLibService.createNew(this.evCallBackWhenClean);
            this.evComponent.onClickButton(ev);
            this.evCallBackWhenClean = null;
        } else {
            if (this.customParameters.fireEventAfter) {
                this.localhasEvent = true;
            }
            if (this.localhasEvent) {
                let DOMessage: DOData = new DOData();
                DOMessage.njDocData = this.DocData;
                this.DocDefTemplate.indent = this.onKeydownKey;
                DOMessage.njDocDefTemplate = this.DocDefTemplate;
                this.onKeydownKey = "";
                this.clickBut.emit(DOMessage);
            }
        }
    }
    ngOnInit() {
        this.txtDocDefTemplate = this.DocDefTemplate;
        this.txtDocData = this.DocData;
        this.txtValue = this.txtDocData.dataValue;

        if (this.customParameters.isSSN != null) {
            this.MaxLength = "11";
        }
        if (this.customParameters.type !=null) {
            if (this.customParameters.type.toLowerCase() == 'password')
                this.inputType = "password";
        }


        this.tabEventSent = false;
        if (this.customParameters['isEnabled'] == 'False')
            this.isEnabled = false;
        this.setHiddenStatus();
        setTimeout(() => this.adjust(), 0);
    }
    getTextStyle(): object {
        if (this.customParameters['TextBoxStyle'] != null) {
            let styles = this.data.replaceAll(this.customParameters['TextBoxStyle'], "'", '"');
            this.TextBoxStyle = JSON.parse(styles);
            if (this.isValid)
                if (this.RowSelected) {
                    if (this.RowSelected['background-color'] == "lightsteelblue") {
                        this.TextBoxStyle['background-color'] = "lightsteelblue";
                        return this.TextBoxStyle;
                    }
                }
                else if (this.isReadOnly == true) {
                    this.TextBoxStyle['background-color'] = "white";
                    return this.TextBoxStyle;
                }
                else {
                    return this.TextBoxStyle;
                }
            else {
                this.TextBoxStyle['background-color'] = "lightpink";
                return this.TextBoxStyle;
            }
        }
        else {
            if (this.isValid)
                return null
            else
                return { "background-color": "lightpink" };
        }
    }
    ngOnChanges(): void {
        this.isLoading = true;
        this.txtDocDefTemplate = this.DocDefTemplate;
        this.txtDocData = this.DocData

        if (this.customParameters.isPhone != null) {
            this.txtDocData.dataValue = this.fmtPhone(this.txtDocData.dataValue);
        }
        if (this.customParameters.isSSN != null) {
            this.txtDocData.dataValue = this.fmtSSN(this.txtDocData.dataValue);
        }

        this.txtValue = this.txtDocData.dataValue;


        if (this.customParameters['TextValue'] != null) {
            this.isLoading = false;
            this.txtDocData.dataValue = this.customParameters['TextValue'];
            this.txtValue = this.txtDocData.dataValue;
        }
        this.isLoading = false;
        if (this.customParameters['StylesText'] != null) {
            let styles = this.data.replaceAll(this.customParameters['StylesText'], "'", '"');
            if (styles)
                this.StylesText = JSON.parse(styles);
        }
        if (this.customParameters['TextBoxStyles'] != null) {
            let styles = this.data.replaceAll(this.customParameters['TextBoxStyles'], "'", '"');
            if (styles)
                this.TextBoxStyles = JSON.parse(styles);
        }
        if (this.customParameters['TextBoxClasses'] != null) {
            let classes = this.data.replaceAll(this.customParameters['TextBoxClasses'], "'", '"');
            if (classes)
                this.TextBoxClasses = JSON.parse(classes);
        }
        if (this.customParameters['LabelStylesText'] != null) {
            let styles = this.data.replaceAll(this.customParameters['LabelStylesText'], "'", '"');
            if (styles)
                this.LabelStylesText = JSON.parse(styles);
        }
        if (this.customParameters['maxLength'] != null)
            this.MaxLength = this.customParameters['maxLength'];
        // for grids allow edit in popup.
        if (this.isPopUpYesNo == "No")
            this.isReadOnly = true;
        this.setReadonlyStatus();
        if (this.customParameters['testText'] == 'No')
            this.boolUseTestText = false;
        else
            this.boolUseTestText = true;
        //if (!this.customParameters.Textarea)
        //    this.showTestText = 99;
        if (this.customParameters['Tab'] && !this.tabEventSent) {
            let message: componentVM = new componentVM();
            message.thisComponent = this;
            message.tag = this.customParameters['Tab']
            this.tabEvent.emit(message);
            this.tabEventSent = true;
        }
        if (this.customParameters['hasEvent'] == 'Yes')
            this.hasEvent = true;
    }
    StackLabelNo() {
        if (this.customParameters['StackLabel'] == 'No')
            return "form-inline";
        else
            if (this.customParameters['StackLabel'] == null && this.customParameters['FormGroupItem'] == 'Yes')
                return "form-group flex-nowrap";
            else
                return "";
    }
    classFromParams() {
        let ret: string = "";
        if (this.customParameters.DisabledStyle == 'Yes') {
            ret = "input-block-level";
        }
        else if (this.customParameters.DisabledStyle == 'No') {
            ret = "input-block-level-white";
        }
        if (this.customParameters['InputClass'] != null) {
            ret = ret + " " + this.customParameters['InputClass'];//form-control-range
        }
        return ret;
    }

    labelWidth(): string {
        if (this.customParameters['LabelWidth'] == null) {
            if (this.customParameters['StackLabel'] == 'Yes')
                return "col-md-12 col-sm-12";
            else
                return "col-md-6 col-sm-6";
        } else {
            return this.customParameters['LabelWidth'];
        }
    }
    inputWidth(): string {
        if (this.customParameters['InputWidth'] == null) {
            if (this.txtDocDefTemplate.tLabel.length <= 0 || this.ignorLabel)
                return "col-md-12 col-sm-12"
            else
                if (this.customParameters['StackLabel'] == 'Yes')
                    return "col-md-12 col-sm-12";
                else
                    if (this.customParameters['FormGroupItem'] == null)
                        return "col-md-6 col-sm-6";
                    else
                        return "";
        } else {
            return this.customParameters['InputWidth'];
        }
    }
    // notify parent that doubleClick ocurred on this item
    public onTbDblClick() {
        let item: DOData = new DOData();
        item.njDocData = this.DocData;
        item.njDocDefTemplate = this.DocDefTemplate;
        this.tbDblClick.emit(item);
    }
    setFocus() {
        let element: any = null;
        if (this.customParameters.Textarea) {
            element = this.element.nativeElement.getElementsByTagName('textarea')[0];
        } else {
            element = this.element.nativeElement.getElementsByTagName('input')[0];
        }
        if (element)
            element.focus();
        else
            console.log('Set focus: Element undefined in: ' + this.DocDefTemplate.templateCode);
    }
    clearTextbox() {
        this.txtDocData.dataValue = "";
        this.isDirty = true;
        this.onBlurText();
    }
    setTextToValue(value: string) {
        this.txtDocData.dataValue = value;
        this.isDirty = true;
        this.onBlurText();
    }
    setHiddenStatus() {
        if (this.customParameters.Hidden == 'Yes')
            this.isHidden = true;
        //is the the required seccode in the user's credentials
        else if (this.customParameters["HiddenIfMissingSecCode"]) {
            //this.data.checkIfCodeInUserSecurity(this.customParameters["HiddenIfMissingSecCode"]).subscribe((ret: boolean) => {
            //    if (ret) {
            //        this.isHidden = false;
            //    }
            //    else {
            //        this.isHidden = true;
            //    }
            //        });
        }
        else this.isHidden = false;
    }

    setReadonlyStatus() {
        if (this.customParameters.isReadOnly == 'Yes')
            this.isReadOnly = true;
        //is the the required seccode in the user's credentials
        else if (this.customParameters["DisabledIfMissingSecCode"]) {
            //this.data.checkIfCodeInUserSecurity(this.customParameters["DisabledIfMissingSecCode"]).subscribe((ret: boolean) => {
            //    if (ret) {
            //        this.isReadOnly = false;
            //    }
            //    else {
            //        this.isReadOnly = true;
            //    }
            //});
        }
        else this.isReadOnly = false;
    }

    ngAfterViewInit() {
        this.textBoxAfterViewInit.emit(this);
    }
}
